import { companyApi } from '../../../apis/companyApi';
import { createLatestRequestGuard } from '@/utils/latestRequestWins';

const companyRequestGuard = createLatestRequestGuard();

export default {
  namespaced: true,
  state: {
    companies: [],
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 10,
    loading: false,
    error: null
  },
  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies;
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_TOTAL_PAGES(state, total) {
      state.totalPages = total;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_TOTAL_ELEMENTS(state, totalElements){
      state.totalElements = totalElements;
    }
  },
  actions: {
    async initialize({ dispatch }) {
      console.log('Company module initialize called');
      try {
        await dispatch('fetchCompanies', { page: 0, size: 10 });
        console.log('Initial companies fetch completed');
      } catch (error) {
        console.error('Error in company initialize:', error);
      }
    },
    async fetchCompanies({ commit }, params) {
      console.log('Fetching companies with params:', params);
      const request = companyRequestGuard.begin();
      commit('SET_LOADING', true);
      try {
        const response = await companyApi.getCompanies(params, { signal: request.signal });
        if (!companyRequestGuard.isCurrent(request.token)) return;

        console.log('API Response:', response.data.content.content);
        commit('SET_COMPANIES', response?.data?.content?.content || []);
        commit('SET_TOTAL_PAGES', response?.data?.content?.page?.totalPages);
        commit('SET_TOTAL_ELEMENTS', response?.data?.content?.page?.totalElements);
      } catch (error) {
        if (!companyRequestGuard.isCurrent(request.token)) return;
        console.error('Error fetching companies:', error);
        commit('SET_ERROR', error.message);
      } finally {
        if (companyRequestGuard.isCurrent(request.token)) {
          commit('SET_LOADING', false);
          companyRequestGuard.finish(request.token);
        }
      }
    },
    cancelRequests({ commit }) {
      companyRequestGuard.cancel();
      commit('SET_LOADING', false);
    },
    async createCompany({ dispatch }, companyData) {
      try {
        const response = await companyApi.createCompany(companyData);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchCompanies', {
            page: 1,
            size: 10,
            sort: 'id,desc'
          });
          return response.data.data;
        }
      } catch (error) {
        console.error('Error creating company:', error);
        throw error;
      }
    },
    async updateCompany({ dispatch }, companyData) {
      try {
        const response = await companyApi.updateCompany(companyData.id, companyData);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchCompanies', {
            page: 1,
            size: 10,
            sort: 'id,desc'
          });
          return response.data.data;
        }
      } catch (error) {
        console.error('Error updating company:', error);
        throw error;
      }
    },
    async deleteCompany({ dispatch }, companyId) {
      try {
        const response = await companyApi.deleteCompany(companyId);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchCompanies', {
            page: 1,
            size: 10,
            sort: 'id,desc'
          });
          return response.data.data;
        }
      } catch (error) {
        console.error('Error deleting company:', error);
        throw error;
      }
    }
  },
  getters: {
    getCompanies: state => state.companies,
    getCurrentPage: state => state.currentPage,
    getTotalPages: state => state.totalPages,
    getTotalElements: state => state.totalElements,
    isLoading: state => state.loading,
    getError: state => state.error
  }
};
